import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { isConsumer } from 'owa-session-store';
export default function shouldAlwaysShowFrom() {
    var userOptions = getUserConfiguration().UserOptions;
    var sessionSettings = getUserConfiguration().SessionSettings;
    return (userOptions.AlwaysShowFrom ||
        (isConsumer() &&
            (sessionSettings.ConnectedAccountInfos.length > 0 ||
                (sessionSettings.NotManagedEmailAddresses &&
                    sessionSettings.NotManagedEmailAddresses.length > 0) ||
                sessionSettings.UserProxyAddresses.length > 1)));
}
//# sourceMappingURL=shouldAlwaysShowFrom.js.map